module.exports = __webpack_public_path__ + "5fe948763d30ce538b6086773cf9434e.svg";